import script from "./Addition.vue?vue&type=script&setup=true&lang=js"
export * from "./Addition.vue?vue&type=script&setup=true&lang=js"

import "./Addition.vue?vue&type=style&index=0&id=5d4e172c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d4e172c"]])

export default __exports__